<template>
  <div class="text-scorpion">
    <span class="authorName font-weight-bold text-break">{{ name }}</span> | <span v-if="publishDate" class="postDate">{{ publishDate }}</span>
  </div>
</template>

<script>
export default {
  name: 'PostAuthor',
  props: {
    name: {
      type: String,
      required: true
    },
    publishDate: {
      type: String,
      required: false
    },
  }
};
</script>

<style lang="scss">
.postAuthorContainer {
  min-height: 55px;
}
</style>
